// extracted by mini-css-extract-plugin
module.exports = {"default":"text-box-cta_default__25bWs","btn":"text-box-cta_btn__3BFjJ","buttons":"text-box-cta_buttons__2Xcv0"};